import React from "react";
import WarehouseInventory from "./WarehouseInventory";
import { ALL_TABS } from "./utils/inventory.constants";

const INBOUND_ONLY_TABS = ALL_TABS.filter((item) => item.key === "inbound");

export default function WarehouseInboundReceiptsPage() {
  return (
    <WarehouseInventory
      initialTab="inbound"
      allowedTabs={INBOUND_ONLY_TABS}
      showTabs={false}
      pageTitle="Inbound Receipts"
      pageDescription="View approved inbound receipts, inspect receipt details, and receive stock batches into warehouse inventory."
    />
  );
}